
  import {Component, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportTable from "@/modules/Report/components/ReportTable.vue";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import {IApp} from "@/interfaces/app.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";

  @Component({
    components: {
      ReportTable,
    }
  })
  export default class ReportTableCarsBalance extends Vue {

    get tableList(): IReport.ICarsBalance[] { return this.$store.getters['report/sortedList'].array; }
    get dataProps(): IReport.ITableProp[] {
      return [
        { label: 'Машина',     prop: 'carNumber', propType: IApp.SortingPropType.String, actionClick: this.openCarPopup },
        { label: 'Владелец',   prop: 'persName',  propType: IApp.SortingPropType.String, },
        { label: 'Дата',       prop: 'dateBeg',   propType: IApp.SortingPropType.Date, dateFormat: 'DD.MM.YYYY', colspan: 2, },
        { label: 'Тип',        prop: 'typeName',  propType: IApp.SortingPropType.String, },
        { label: 'Начисление', prop: 'tSum',      propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Оплата',     prop: 'tSumPay',   propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Сальдо',     prop: 'tSaldo',    propType: IApp.SortingPropType.Number, isMoney: true, },
      ];
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }

    async openCarPopup(tableItem: IReport.ICarsBalance) {
      if (tableItem.carId) {
        let payload: ICarStore.IPopupPayload = {
          carId: tableItem.carId,
          tabForOpen: ICarPopupTables.CarPopupTab.Movements,
        };
        await this.$store.dispatch('car/openCarPopup', payload);
      }
      else {
        await this.$store.dispatch('confirm/open', {
          title: 'Внимание',
          text: `На машину ${tableItem.carNumber} не создана карточка`,
          cancel: { text: '', },
          confirm: { text: 'Ок', },
        }, { root: true, });
      }
    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.$store.state.report.activeReport,
        filters: {...this.$store.state.report.filters},
      });
    }

    printTable() {
      ReportPrintActions.PrintTable(this.printedOptions);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }
  }
